import { rem } from 'polished';

import type {
  GeneratedTheme,
  IconButtonComponentTheme,
  IconButtonThemeVariantValue,
  Theme,
} from '../../types';

type Props = {
  core: Theme['core'];
  semantic: Theme['semantic'];
  components: GeneratedTheme['components'];
};

const mapIconButtonTheme = ({
  core,
  semantic,
  components,
}: Props): IconButtonComponentTheme => {
  const { IconButton } = components;

  const regularVariantSize = IconButton.regular;

  const getIconButtonVariantStyle = (
    variantName: keyof typeof regularVariantSize,
  ): IconButtonThemeVariantValue => {
    const variant = regularVariantSize[variantName];

    const borderWidthPxByVariant: Record<typeof variantName, number> = {
      primary: 0,
      secondary: 0,
      'outlined-primary': 2,
      'outlined-secondary': 1,
      simple: 0,
    };

    return {
      ...variant,
      'border-width': rem(borderWidthPxByVariant[variantName]),
      'icon-size': {
        smallest: core.iconSize.s,
        small: core.iconSize.s,
        medium: core.iconSize.m,
        big: core.iconSize.m,
      },
      padding: {
        smallest: IconButton.small[variantName].padding,
        small: semantic.spacing.inset.xs,
        medium: IconButton.regular[variantName].padding,
        big: IconButton.big[variantName].padding,
      },
    };
  };

  const mapped: IconButtonComponentTheme = {
    primary: getIconButtonVariantStyle('primary'),
    secondary: getIconButtonVariantStyle('secondary'),
    outlined: getIconButtonVariantStyle('outlined-primary'),
    'outlined-secondary': getIconButtonVariantStyle('outlined-secondary'),
    simple: getIconButtonVariantStyle('simple'),
    positive: {
      ...getIconButtonVariantStyle('simple'),
      'bg-hover': '#32395A26',
    },
    negative: {
      ...getIconButtonVariantStyle('simple'),
      'icon-default': '#FFFFFF',
      'icon-hover': '#FFFFFF',
      'bg-hover': '#FFFFFF26',
      'bg-focus': undefined,
      shadow: '#E3E3E7',
    },
  };

  return mapped;
};

export default mapIconButtonTheme;
